import { Drawer, DrawerContent } from '@/components/ui/drawer';
import { BaseModalProps } from '@/contexts/ModalContext';
import { SubscriptionScreen } from '~/purchases/components/subscription-screen/SubscriptionScreen';

export interface PaywallModalProps extends BaseModalProps {}

/**
 * Generic promotional paywall — a modal wrapper around the real
 * {@link SubscriptionScreen} (same plans, live prices, working Subscribe). It is
 * intentionally feature-agnostic: any gated action (custom foods, custom
 * exercises, a drained AI wallet, …) opens the same modal via `usePaywall()`.
 * `onRequestClose` is threaded into the screen so its "X" dismisses the overlay
 * instead of navigating the underlying stack.
 */
export const PaywallModal = ({ onClose }: PaywallModalProps) => {
  return (
    <Drawer open onOpenChange={(open) => !open && onClose()}>
      {/* `overflow-hidden` clips the screen's content to the drawer's rounded
          corners (the inner background is a full rectangle otherwise). */}
      <DrawerContent className="overflow-hidden">
        <SubscriptionScreen onRequestClose={onClose} />
      </DrawerContent>
    </Drawer>
  );
};
